// extracted by mini-css-extract-plugin
export default {"container":"Backoffice-Sites_container__GXB+P"};